import { useEffect, useMemo, useState } from 'react';
import { IEntityState, useStore } from '../../../store';
import { IUser } from '../../../store/modules/user/i-user';
import { USER_ID } from '../../../store/modules/user/user.constants';
import { useActions } from '../../providers/actions-provider/actions.context';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useGetUsers = () => {
  const { userActions } = useActions();
  const { users, currentUser } = useStore();
  const [copyUsers, setCopyUsers] = useState<IEntityState<IUser[]>>(users);
  const localStorageService = useLocalStorage();
  const userID: number | null = localStorageService.get(USER_ID);

  useEffect(() => {
    if (!users.loading) {
      userActions.getUsersList();
    }
    if (userID) {
      userActions.getCurrentUser(userID);
    }
  }, []);

  useEffect(() => {
    setCopyUsers(users);
  }, [users]);

  return useMemo(() => ({
    users: copyUsers,
    onSearch: (e: string, currentFilter: string) => {
      const filteredUsers = users.data.filter((user) => {
        const copyUser = JSON.parse(JSON.stringify(user));
        if (!currentFilter || !copyUser[currentFilter]) {
          return user;
        }
        if (copyUser[currentFilter].toLowerCase().indexOf(e.toLowerCase()) > -1) {
          return user;
        }
        return null;
      });
      setCopyUsers({ ...users, data: filteredUsers });
    },
    currentUser,
  }), [users, copyUsers]);
};

export default useGetUsers;
